/* Umbraco culture codes. "en-US" stays in the union: the CMS can still hold
   English variants of a node, and MagazineArticle still reads culture codes off
   Delivery responses — it is only the frontend LOCALE that was discarded
   (EGDE-669). */
export type Culture = "he-IL" | "en-US" | "ar" | "ru"

type Locale = "he" | "ar" | "ru"

/* Frontend locale → Umbraco culture. EGDE-669: `en` was removed with the English
   version of the site. `localeByCulture` in lib/seo.ts is derived from this map,
   so dropping the entry is also what stops "en-US" content being advertised as
   an `hreflang` alternate or listed in the sitemap. */
export const cultureMap: Record<string, Culture> = {
  he: "he-IL",
  ar: "ar",
  ru: "ru",
} as const

export function getDirection(locale: Locale) {
  return locale === "he" || locale === "ar" ? "rtl" : "ltr"
}
